import { type PositionTeam, positionTeamsQuery } from '@atlassian/search-client';

import { type CloudConfig } from '../../../../../common/constants/filters/cloud-config/types';
import { type FetchedSelectFilterOption } from '../../../../../common/constants/filters/select-filter/types';
import type { ProductKeys, ProductKeys1P } from '../../../../../common/constants/products';
import { createMultiSelectFilter } from '../../../../filters/multi-select-filter';

// Number of results returned in dropdown
const LIMIT = 20;

const mapPositionTeamResult = (
	positionTeam: PositionTeam,
	product: ProductKeys,
): FetchedSelectFilterOption => {
	return {
		trackingKey: positionTeam.node.ari || '',
		label: positionTeam.node.value?.displayName || '',
		value: positionTeam.node.ari || '',
		queryParamValue: positionTeam.node.ari || '',
		product: product,
		avatarUrl: positionTeam.node.value?.smallAvatarImageUrl || '',
	};
};

/**
 * Queries position teams by search term
 * @param query
 * @param config
 * @returns
 */
const searchPositionTeams = async (
	query: string,
	config: CloudConfig,
): Promise<FetchedSelectFilterOption[]> => {
	const rqlQuery = `team ~ '${query}'`;
	const positionTeamsResponse = await positionTeamsQuery(config.cloudId || '', LIMIT, rqlQuery);
	const positionTeams: PositionTeam[] = positionTeamsResponse.data?.radar_fieldValues.edges ?? [];

	return positionTeams.map((positionTeam) =>
		mapPositionTeamResult(positionTeam, config.product as ProductKeys),
	);
};

/**
 * Queries all selected position teams by id from query params
 * @param queryParams
 * @param config
 * @returns
 */
const getOptionsWithSelectionsFromQueryParams = async (
	queryParams: string[],
	config: CloudConfig,
): Promise<FetchedSelectFilterOption[]> => {
	const rqlQuery = `team in ('${queryParams.join(', ')}')`;
	const positionTeamsResponse = await positionTeamsQuery(config.cloudId || '', LIMIT, rqlQuery);
	const positionTeams: PositionTeam[] = positionTeamsResponse.data?.radar_fieldValues.edges ?? [];

	return positionTeams.map((positionTeam) =>
		mapPositionTeamResult(positionTeam, config.product as ProductKeys),
	);
};

const productKeys1P: ProductKeys1P[] = [];

export const filter = createMultiSelectFilter({
	id: 'positionTeam',
	products: productKeys1P,
	alwaysVisible: false,
	universal: false,
	queryParams: {
		key: 'positionTeam',
		fetcher: getOptionsWithSelectionsFromQueryParams,
	},
	initialOptions: {
		fetcher: async (config) => {
			return searchPositionTeams('', config);
		},
	},
	lookup: {
		fetcher: searchPositionTeams,
	},
});
